const Spinner = () => {
  return <div>Loading...</div>;
};

export default Spinner;
